var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('failed-operations',{ref:"failedOperationsTemplate",attrs:{"failed-operations":_vm.failedOperations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }